import { InternalRespinRound, SpinResponse, SpecialSymbolGroup } from '@cgs/data-access';
import { Container } from '@cgs/wge';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { GameStateMachine } from '../../reels_engine/state_machine/game-state-machine';
import { GameComponentProvider } from './game_component_provider';

export abstract class ResponseDependentGameComponentProvider extends GameComponentProvider {
  private readonly _gameStateMachine: GameStateMachine<SpinResponse>;

  protected constructor(protected readonly container: Container) {
    super();
    this._gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
  }

  public get gameStateMachine(): GameStateMachine<SpinResponse> {
    return this._gameStateMachine;
  }

  public get currentResponse(): SpinResponse {
    return this._gameStateMachine.curResponse;
  }

  public getSpecialSymbolsByMarker(response: SpinResponse, marker: string): SpecialSymbolGroup[] {
    return response.specialSymbolGroups?.filter((s) => s.type && s.type === marker) || [];
  }

  public getRespinSpecialSymbolsByMarker(
    respinRound: InternalRespinRound,
    marker: string
  ): SpecialSymbolGroup[] {
    return respinRound && respinRound.specialSymbolGroups
      ? respinRound.specialSymbolGroups.filter((s) => s.type && s.type === marker)
      : [];
  }
}
